/**
* Toggles the "d-none" CSS class on elements related to personalization UI.
* This function shows or hides the personalization content, form, and navigation elements
* by toggling their visibility classes using jQuery selectors.
*
* @returns {void}
*/
function toggleVisibilityClasses() {
    $(".js-personalization-content").toggleClass("d-none");
    $(".js-personalization-form").toggleClass("d-none");
    $(".js-content-back").toggleClass("d-none");
    $(".js-personalization-back").toggleClass("d-none");
}

/**
* Calculates the distance in kilometers between two geographic coordinates using the Haversine formula,
* and returns both the numeric value and formatted string representations. Optionally updates UI elements
* or form fields if specified in the options parameter.
*
* @param {Object} reimsCoordinates - The reference coordinates with properties {lat, lng} (in degrees).
* @param {Object} coordinates - The target coordinates with properties {lat, lng} (in degrees).
* @param {Object} [options={}] - Optional settings for UI or form updates.
* @param {boolean} [options.updatePreview] - If true, updates preview UI elements with the calculated distance.
* @param {boolean} [options.updateForm] - If true, updates form fields with the calculated distance.
* @returns {Object} An object containing:
*   @property {number} distance - The calculated distance in kilometers (rounded up).
*   @property {string} formattedWithSpace - The distance formatted with spaces as thousand separators.
*   @property {string} formattedNoSeparator - The distance formatted as a plain number string without separators.
*/
function calculateDistance(reimsCoordinates, coordinates, options = {}) {
    const earthRadiusKm = 6371;

    const toRadians = (degrees) => degrees * (Math.PI / 180);

    const reimsLatitudeRad = toRadians(reimsCoordinates.lat);
    const reimsLongitudeRad = toRadians(reimsCoordinates.lng);
    const targetLatitudeRad = toRadians(coordinates.lat);
    const targetLongitudeRad = toRadians(coordinates.lng);

    const deltaLatitude = targetLatitudeRad - reimsLatitudeRad;
    const deltaLongitude = targetLongitudeRad - reimsLongitudeRad;

    const haversineFormula =
        Math.sin(deltaLatitude / 2) ** 2 +
        Math.cos(reimsLatitudeRad) *
            Math.cos(targetLatitudeRad) *
            Math.sin(deltaLongitude / 2) ** 2;

    const centralAngle = 2 * Math.asin(Math.sqrt(haversineFormula));
    const distance = Math.ceil(earthRadiusKm * centralAngle);

    // Format outputs
    const formattedWithSpace = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    })
        .format(distance)
        .replace(/,/g, " ");

    const formattedNoSeparator = formattedWithSpace.replace(/ /g, "");

    // Optional UI output (only runs if selectors are passed)
    if (options.updatePreview) {
        $(".js-personalization-value").html($(".js-preview-text").text());
        $(".js-personalization-km #personalizationDistance").html(formattedWithSpace);
        if (typeof toggleVisibilityClasses === "function") {
            toggleVisibilityClasses();
        }
    }

    if (options.updateForm) {
        const $personalizationDistance = $("#personalization-form-distance");
        if ($personalizationDistance.length) {
            $personalizationDistance.val(formattedNoSeparator);
        }

        const $personalizationDistanceText = $(".js-personalization-distance-text");
        if ($personalizationDistanceText.length) {
            $personalizationDistanceText
                .find(".js-personalization-distance")
                .text(formattedWithSpace);
        }
    }

    // Always return the numeric distance + formatted values
    return {
        distance,
        formattedWithSpace,
        formattedNoSeparator
    };
}

module.exports = {
    calculateDistance: calculateDistance
};
